import {connect} from "react-redux";
import React from "react";
import PropTypes from "prop-types";
import {replace} from "react-router-redux";
import LoadingBlocking from "../../../components/loading/LoadingBlocking";
import * as authActions from "../../../actions/auth/authWithOtp/authActions2";
import reduxRouteChanged from "../../../services/reduxRouteChanged";
import {OtpForm} from "../../../auth/OtpForm";
import Layout from "../../../auth/Layout";
import {OtpTooManyAttempts} from "../../../auth/OtpTooManyAttempts";
import {loginOtpUrl} from "../../../utils/url/loginOtpUrl";
import loginUrl from "../../../utils/url/loginUrl";
import {loginOtpTypeUrl} from "../../../utils/url/loginOtpTypeUrl";
import {OTP_ACTIVITY_BLOCKED_UNTIL} from "../../../auth/authWithOtp/constants2";

@connect(
  state => {
    return {
      phoneLast4digits: state.auth.phoneLast4digits,
      otpType: state.auth.otpType,
      loginRequestToken: state.auth.loginRequestToken,

      isOtpSuccess: state.auth.isOtpSuccess,
      isLoadingOtp: state.auth.isLoadingOtp,
      isOtpFail: state.auth.isOtpFail,
      loginOtpVerifyError: state.auth.loginOtpVerifyError,

      otpAttempts: state.auth.otpAttempts,
    };
  },
  dispatch => ({
    redirect: (path) => dispatch(replace(path)),
    verifyOtp: (verificationCode, otpType, token) => dispatch(authActions.verifyLoginOtp(verificationCode, otpType, token)),
    otpFocusAfterFail: () => dispatch(authActions.loginOtpFocusAfterFail()),
  })
)
class OtpRegisterController extends React.Component {

  static propTypes = {
    phoneLast4digits: PropTypes.string,
    loginRequestToken: PropTypes.string,
    verifyOtp: PropTypes.func,
    otpFocusAfterFail: PropTypes.func,
    redirect: PropTypes.func,
    otpType: PropTypes.string,
    isOtpSuccess: PropTypes.bool,
    isLoadingOtp: PropTypes.bool,
    isOtpFail: PropTypes.bool,
    loginOtpVerifyError: PropTypes.object,
    otpAttempts: PropTypes.number,
  };

  constructor(props) {
    super(props);

    this.state = {
      lastSendVerificationCode: undefined,
      isBlocked: false,
      blockedUntil: undefined,
    };
  }

  componentDidMount() {
    if (!this.props.loginRequestToken) {
      this.props.redirect(loginUrl());
    }
  }

  componentDidUpdate(prevProps) {
    const { isOtpFail, loginOtpVerifyError } = this.props;
    if (!prevProps.isOtpFail && isOtpFail) {
      if (loginOtpVerifyError && loginOtpVerifyError.code === OTP_ACTIVITY_BLOCKED_UNTIL) {
        this.setState(state => {
          return {
            ...state,
            isBlocked: true,
            blockedUntil: +loginOtpVerifyError.message,
          };
        });
      }
    }
  }

  navigateToLogin() {
    this.props.redirect(loginOtpUrl());
  }

  onOtpComplete(verificationCode) {
    const { otpType, loginRequestToken } = this.props;
    this.setState(state => {
      return {
        ...state,
        lastSendVerificationCode: verificationCode,
      };
    });
    this.props.verifyOtp(verificationCode, otpType, loginRequestToken);
  }

  resendOtp() {
    this.props.redirect(loginOtpTypeUrl());
  }

  render() {
    return (
      <Layout>
        {(this.props.isLoadingOtp) && <LoadingBlocking/>}

        {!this.state.isBlocked && <OtpForm phone={this.props.phoneLast4digits ? `(***) *** - ${this.props.phoneLast4digits}` : ''}
                          isFail={this.props.isOtpFail}
                          isSuccess={this.props.isOtpSuccess}
                          otpComplete={(verificationCode) => this.onOtpComplete(verificationCode)}
                          otpFocusAfterFail={this.props.otpFocusAfterFail}
        sendAgain={() => this.resendOtp()}/>}

        {this.state.isBlocked && <OtpTooManyAttempts timeLeft={this.state.blockedUntil}
                                                     onTimerEnd={() => this.navigateToLogin()}></OtpTooManyAttempts>}
      </Layout>
    );
  }
}


function initStore() {}

export default reduxRouteChanged(initStore,  OtpRegisterController);



// WEBPACK FOOTER //
// ./src/containers/auth/login/OtpLoginController.js